module.exports = __webpack_public_path__ + "assets/638fd23bbc8523124320a4bee32cc43b.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-cyrillic-ext-700-normal.woff2
// module id = 2625
// module chunks = 121